// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;

// @ constants
const actionTypes = require('constants/actionTypes');
const { COMMERCIAL_ADS_CHANNEL } = require('constants/index');

function reset () {
    return {
        type: actionTypes.HIRE_CARD_IMAGE_SELECTOR_RESET
    };
}

function validateStep () {
    return {
        type: actionTypes.HIRE_CARD_IMAGE_UPDATE_VALIDATE_STEP
    };
}

const hireCardImagesUpdateSelectedId = id => ({
    type: actionTypes.HIRE_CARD_IMAGE_UPDATE_SELECTED_ID,
    payload: {
        id
    }
});

const hireCardImagesRequest = () => ({
    type: actionTypes.HIRE_CARD_IMAGE_SELECTOR_REQUEST
});

const hireCardImagesSuccess = (idsOrder, images, extraImage) => ({
    type: actionTypes.HIRE_CARD_IMAGE_SELECTOR_SUCCESS,
    payload: {
        idsOrder,
        images,
        extraImage
    }
});

const hireCardImagesFailure = error => ({
    type: actionTypes.HIRE_CARD_IMAGE_SELECTOR_FAILURE,
    payload: {
        error
    }
});

const getHireCardImages = (ids, extraImage = '', isCharity = false) => (dispatch, getState) => {
    if (!getState().hireCardImageSelector.get('isFetching')) {

        dispatch(hireCardImagesRequest());

        if (!!extraImage) {
            ids.push(extraImage);
        }

        const params = {
            query: {
                channel: COMMERCIAL_ADS_CHANNEL,
                lang: getLanguage().toLowerCase(),
                locations: ids.toString()
            }
        };

        return APIPost({
                dispatch,
                endpoint: 'requestAds',
                params
            })
            .then(response => {
                if (Array.isArray(response.nodes)) {
                    const responseNodes = isCharity ? response.nodes.slice(0).reverse() : response.nodes;
                    dispatch(hireCardImagesSuccess(ids, responseNodes, extraImage));
                }
            })
            .catch(response => {

                if (!!response.error) {
                    dispatch(hireCardImagesFailure(response.error));
                } else {
                    throw response;
                }
            });
    }
};

module.exports = {
    getHireCardImages,
    hireCardImagesUpdateSelectedId,
    reset,
    validateStep
};
